import React, { Component, createContext } from 'react'
import OneGraphAuth from 'onegraph-auth'
export const AuthContext = createContext()

class AuthContextProvider extends Component {
  state = {
    isAuthenticated:
      typeof window !== 'undefined' && localStorage.getItem('isLoggedIn')
        ? JSON.parse(localStorage.getItem('isLoggedIn'))
        : false,
  }

  isLoggedInFunction = () => {
    const APP_ID = '81900dbc-b8b5-4537-bae2-9e7523d63fef'

    const auth = new OneGraphAuth({
      appId: APP_ID,
    })
    auth.isLoggedIn('github').then(isLoggedIn => {
      if (isLoggedIn) {
      } else {
      }
    })
  }
  loginAction = () => {
    const APP_ID = '81900dbc-b8b5-4537-bae2-9e7523d63fef'

    const auth = new OneGraphAuth({
      appId: APP_ID,
    })
    auth
      .login('github')
      .then(() => {
        auth.isLoggedIn('github').then(isLoggedIn => {
          if (isLoggedIn) {
            // showWelcomeBack = true
            // setAuthenticatedWithGitHub(!authenticatedWithGitHub)
            // console.log('authenticatedWithGitHub', authenticatedWithGitHub)
            localStorage.setItem('isLoggedIn', true)
            this.setState({
              isAuthenticated: JSON.parse(localStorage.getItem('isLoggedIn')),
            })
          } else {
            console.log('Did not grant auth for GitHub')
          }
        })
      })
      .catch(e => console.error('Problem logging in', e))
  }
  logoutAction = () => {
    localStorage.setItem('isLoggedIn', false)

    this.setState({
      isAuthenticated: JSON.parse(localStorage.getItem('isLoggedIn')),
    })
  }
  render() {
    return (
      <AuthContext.Provider
        value={{
          ...this.state,
          loginAction: this.loginAction,
          logoutAction: this.logoutAction,
        }}
      >
        {this.props.children}
      </AuthContext.Provider>
    )
  }
}

export default AuthContextProvider
